// tslint:disable
/* MACLE TypeScript 17/07/2025 17:31:44 */
import { FilterPagarMeTransacao } from '../vo/liquidacaoparcelaejb.vo';
import { DataZoopTransacaoAPP, PKZoopTransacaoAPP } from '../vo/sitevo.vo';
import { BaseVO } from '../vo/maf.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class PagarMeTransacaoModelService extends BaseService {
  private _url = 'pagarmetransacaoService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public add(vo: DataZoopTransacaoAPP): Promise<PKZoopTransacaoAPP> {
    let params = {
      "vo": vo
    };
    return this.ajax.post(this._url + 'add', params)
      .then((r: IModelServiceResponse<PKZoopTransacaoAPP>) => Parser.jsonToClass(r.value, PKZoopTransacaoAPP))
      .catch((error: any) => this.handleError(error));
  }

  public exists(pk: PKZoopTransacaoAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'exists', params)
      .then((r: IModelServiceResponse<boolean>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public getPage(filter: FilterPagarMeTransacao, PageIdx: number, NumRecInPage: number): Promise<DataZoopTransacaoAPP[]> {
    let params = {
      "filter": filter,
      "PageIdx": PageIdx,
      "NumRecInPage": NumRecInPage
    };
    return this.ajax.post(this._url + 'getPage', params)
      .then((r: IModelServiceResponse<ArrayList<DataZoopTransacaoAPP>>) => Parser.jsonToClass(r.value, DataZoopTransacaoAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getCount(filter: FilterPagarMeTransacao): Promise<number> {
    let params = {
      "filter": filter
    };
    return this.ajax.post(this._url + 'getCount', params)
      .then((r: IModelServiceResponse<number>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

  public edit(vo: DataZoopTransacaoAPP): Promise<boolean> {
    let params = {
      "vo": vo
    };
    return this.ajax.post(this._url + 'edit', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

  public getData(pk: PKZoopTransacaoAPP): Promise<DataZoopTransacaoAPP> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'getData', params)
      .then((r: IModelServiceResponse<DataZoopTransacaoAPP>) => Parser.jsonToClass(r.value, DataZoopTransacaoAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getList(filter: BaseVO): Promise<DataZoopTransacaoAPP[]> {
    let params = {
      "filter": filter
    };
    return this.ajax.post(this._url + 'getList', params)
      .then((r: IModelServiceResponse<ArrayList<DataZoopTransacaoAPP>>) => Parser.jsonToClass(r.value, DataZoopTransacaoAPP))
      .catch((error: any) => this.handleError(error));
  }

  public del(pk: PKZoopTransacaoAPP): Promise<boolean> {
    let params = {
      "pk": pk
    };
    return this.ajax.post(this._url + 'del', params)
      .then((r: IModelServiceResponse<string>) => r.value === "OK")
      .catch((error: any) => this.handleError(error));
  }

}


